<template>
    <div class="app-container">
        <div class="filter-container">
            <el-button icon="el-icon-plus" type="primary" size="mini" @click="openCreate">
                {{$t('pump.mqtt.createServer')}}
            </el-button>
        </div>
        <div>
            <el-table
                v-loading="listLoading"
                :data="list"
                element-loading-text="Loading"
                border
                fit
                highlight-current-row
                stripe>
            <el-table-column prop="clientId" :label="$t('pump.mqtt.clientId')" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.clientId }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="status" :label="$t('pump.mqtt.status')" width="80" align="center">
                <template slot-scope="scope">
                    <template v-if="scope.row.status==1">
                        <span>{{$t('pump.mqtt.unconnected')}}</span>
                    </template>
                    <template v-else-if="scope.row.status==2">
                        <span>{{$t('pump.mqtt.connected')}}</span>
                    </template>
                    <template v-else-if="scope.row.status==3">
                        <span>{{$t('pump.mqtt.connecting')}}</span>
                    </template>
                    <template v-else-if="scope.row.status==5">
                        <span>{{$t('pump.mqtt.stoping')}}</span>
                    </template>
                    <template v-else>
                        <span>{{$t('pump.mqtt.connectfail')}}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="serverAddress" :label="$t('pump.mqtt.serverAddress')" width="200" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.serverAddress }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="userName" :label="$t('pump.mqtt.userName')" align="center">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <el-input v-model="scope.row.userName" maxlength="33" :show-word-limit="true" size="small"/>
                    </template>
                    <span v-else>{{ scope.row.userName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="password" :label="$t('pump.mqtt.password')" align="center">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <el-input v-model="scope.row.password" maxlength="50" :show-word-limit="true" size="small"/>
                    </template>
                    <span v-else>{{ scope.row.password }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="topicSpec" :label="$t('pump.mqtt.topicSpec')" width="200" align="center">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <el-input maxlength="160" :show-word-limit="true" v-model="scope.row.topicSpec" size="small"/>
                    </template>
                    <span v-else>{{ scope.row.topicSpec }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="keepInterval" :label="$t('pump.mqtt.keepInterval')" width="80" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.keepInterval }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="recoveryInterval" :label="$t('pump.mqtt.recoveryInterval')" width="80" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.recoveryInterval }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="feedHandler" :label="$t('pump.mqtt.feedHandle')" align="center">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <el-input maxlength="33" :show-word-limit="true" v-model="scope.row.feedHandle" size="small"/>
                    </template>
                    <span v-else>{{ scope.row.feedHandle }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('commons.actions')" width="100">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <div class="iori-buttons">
                            <a class="iori-button" @click="updateServer(scope.row)" :title="$t('commons.save')"><i class="el-icon-circle-check"></i></a>
                            <a class="iori-button"  @click="cancelServerEdit(scope.row)" :title="$t('commons.cancel')"><i class="el-icon-circle-close"></i></a>
                        </div>
                    </template>
                    <template v-else>
                        <div class="iori-buttons">
                            <template v-if="scope.row.status == 1 || scope.row.status == 4">
                                <a class="iori-button" @click="startServer(scope.row)" :title="$t('pump.mqtt.start')"><i class="el-icon-video-play"></i></a>
                                <a class="iori-button" @click="deleteServer(scope.row)" :title="$t('commons.delete')"><i class="el-icon-delete"></i></a>
                                <a class="iori-button" @click="editServer(scope.row)" :title="$t('commons.edit')"><i class="el-icon-edit-outline"></i></a>
                            </template>
                            <template v-else>
                                <a class="iori-button" @click="stopServer(scope.row)" :title="$t('pump.mqtt.stop')"><i class="el-icon-video-pause"></i></a>
                            </template>
                        </div>
                    </template>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <el-dialog :visible.sync="editModel" width="40%" :close-on-click-modal="false">
            <template slot="title">
                <title-icon/>{{ $t('pump.mqtt.createServer') }}
            </template>
            <el-form :model="server.form" ref="serverAddress" :rules="server.form.rule" label-width="100px">
                <el-form-item :label="$t('pump.mqtt.serverAddress')">
                    <el-input v-model="server.form.serverAddress" maxlength="160" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('pump.mqtt.clientId')">
                    <el-input v-model="server.form.clientId" maxlength="33" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('pump.mqtt.userName')">
                    <el-input v-model="server.form.userName" maxlength="33" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('pump.mqtt.password')">
                    <el-input v-model="server.form.password" maxlength="50" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('pump.mqtt.topicSpec')">
                    <el-tooltip content="topic=qos;(topic/a/#=1;topic/b/#=0;)" placement="top-start">
                        <el-input v-model="server.form.topicSpec" maxlength="160" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item :label="$t('pump.mqtt.connectTimeout')">
                    <el-input v-model="server.form.connectTimeout" maxlength="3" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('pump.mqtt.keepInterval')">
                    <el-input v-model="server.form.keepInterval" maxlength="3" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('pump.mqtt.recoveryInterval')">
                    <el-input v-model="server.form.recoveryInterval" maxlength="3" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('pump.mqtt.feedHandle')">
                    <el-input v-model="server.form.feedHandle" maxlength="33" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer">
                <el-button @click="cancelCreate()">{{$t('commons.cancel') }}</el-button>
                <el-button type="primary" @click="saveServer()">{{$t('commons.save') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    let manager = require("@/api/business/iot/mqtt/server.js")

    export default {
        data() {
            return {
                list: null,
                listLoading: false,
                editModel: false,
                server: {
                    form: {
                        serverAddress: null,
                        clientId: null,
                        userName: null,
                        password: null,
                        topicSpec: null,
                        connectTimeout: null,
                        keepInterval: null,
                        recoveryInterval: null,
                        feedHandle: null
                    },
                    rule: {

                    }
                }
            }
        },
        created() {
            this.getServerList();
        },
        methods: {
            getServerList() {
                this.listLoading = true;
                manager.getServerListenerList().then((r) => {
                    this.list = r.map((v)=> {
                        this.$set(v, 'edit', false)
                        this.setOrgServer(v);
                        return v
                    });
                    this.listLoading = false;
                }).catch(() => {
                    this.listLoading = false;
                })
            },
            editServer(row) {
                row.edit = true
            },
            cancelServerEdit(row) {
                this.resetOrgServer(row);
                row.edit = false;
            },
            updateServer(row) {
                this.listLoading = true;
                manager.updateServerListener(row).then(() => {
                    this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                    row.edit = false;
                    this.listLoading = false;
                    this.setOrgServer(row);
                }).catch(() => {
                    this.listLoading = false;
                })
            },
            deleteServer(row) {
                this.$confirm(this.$t('message.deleteConfirm'), this.$t('commons.warning'), {
                    confirmButtonText: this.$t('commons.confirm'),
                    cancelButtonText: this.$t('commons.cancel'),
                    type: 'warning'
                }).then(() => {
                    manager.delServerListener(row).then(() => {
                        this.$message({type: 'success', message: this.$t('message.deleteSuccess')});
                        this.getServerList();
                    })
                }).catch(error => {
                    console.log(`未删除，原因 => ${error}`)
                });
            },
            cancelCreate() {
                this.editModel = false;
            },
            openCreate() {
                this.editModel = true;
            },
            setOrgServer(row) {
                row.orgServerAddress = row.serverAddress;
                row.orgUserName = row.userName;
                row.orgPassword = row.password;
                row.orgFeedHandle = row.feedHandle;
                row.orgTopicSpec = row.topicSpec;
            },
            resetOrgServer(row) {
                row.serverAddress = row.orgServerAddress;
                row.userName = row.orgUserName;
                row.password = row.orgPassword;
                row.feedHandle = row.orgFeedHandle;
                row.topicSpec = row.orgTopicSpec;
            },
            startServer(row) {
                manager.startServer(row).then((r)=>{
                    if(r == 1) {
                        this.$message({type: 'success', message: this.$t('pump.mqtt.connecting')});
                        this.getServerList();
                    }
                })
            },
            stopServer(row) {
                manager.stopServer(row).then((r)=>{
                    if(r == 1) {
                        this.$message({type: 'success', message: this.$t('pump.mqtt.stoping')});
                        this.getServerList();
                    }
                })
            },
            saveServer() {
                this.listLoading = true;
                manager.createServerListener(this.server.form).then(()=> {
                    this.$message({type: 'success', message: this.$t('message.saveSuccess')});
                    this.listLoading = false;
                    this.editModel = false;
                    this.getServerList();
                })
            }
        }
    }
</script>
